/* eslint-disable radix */
import classNames from 'classnames';
import React, { memo, useEffect, useRef, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import styles from './AutoHeightGridInfinteScroll.module.less';
import { scrollingDom } from '../../utils/utils';
import ResizeObserver from 'resize-observer-polyfill';
import ScrollTopWhite from '../ScrollTopWhite/ScrollTopWhite';
import BatchAdd from '../../pages/Wallpaper/WallpaperComponents/BatchAdd';

function GridInfinteScroll(props) {
  const {
    dataSource, // 数据集
    minimumBatchSize = 3, // 一行最多统一时间加载个数 默认10
    threshold = 3, // 预加载个数
    getItemSize, // 虚拟列表加载个数
    loadData, // 异步加载更多
    count = 0,
    columnWidth = [],
    template,
    tpl,
    gap = 25,
    radio = 9 / 16, // 高/宽图片比例
    getHeight,
    resizeTemplate,
    blank = () => {},
    loading = null, //新加看是否在loading的判断默认开启
    columnCountByScreen,
    isWpPage = false,
  } = props;
  const [data, SetData] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [node, setNode] = useState(null);
  const [el, setEl] = useState(null);
  const [nodeStyle, setNodestyle] = useState({ width: 0, height: 800 });
  const [column, setColumn] = useState({});
  const [columnHeight, setColumnHeight] = useState({});
  const [scrollTop, setScrollTop] = useState(0);
  const [isScroll, setIsScroll] = useState(false);
  const [isResize, setIsResize] = useState(false);
  const timer = useRef(null);

  const listRef = useRef(null);

  const handleScroll = () => {
    setIsScroll(true);
    if (el && el.scrollTop > 1500) {
      setScroll(true);
    } else if (el) {
      setScroll(false);
    }
    if (el) {
      setScrollTop(Math.min(el.scrollTop, 400));

      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
      timer.current = setTimeout(() => {
        setIsScroll(false);
      }, 300);
    }
  };

  const handleScrollToTop = () => {
    let speed = 80;
    if (el && el.scrollTop > 0) {
      if (el.scrollTop > 1000) {
        speed = parseInt(el.scrollTop / 1000) * 50;
      }
      scrollingDom(el, 0, speed);
    }
  };

  useEffect(() => {
    if (getHeight) {
      getHeight(columnHeight);
    }
  }, [columnHeight]);
  // 算每行的个数
  const handleSize = () => {
    const calFunc = entries => {
      let tempCss = {};
      const tempColumn = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        const compCss = {
          height: parseInt(height),
          width: parseInt(width),
        };
        tempCss = compCss;
        setNodestyle(compCss);

        for (let index = 0; index < columnWidth.length; index += 1) {
          // 根据元素宽度计算卡片宽度
          const tempWidth = width - 40 > 1660 ? 1660 : width - 40;
          if (
            columnCountByScreen &&
            columnWidth[index] &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(columnWidth[index]) &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(gap) &&
            columnWidth[index] < tempWidth
          ) {
            let countArr = [3, 2, 3];
            const tempScrollWidth = width - 26;
            if (tempScrollWidth >= 600 && tempScrollWidth < 1030 && columnCountByScreen[600]) {
              countArr = columnCountByScreen[600];
            }
            if (tempScrollWidth >= 1030 && tempScrollWidth < 1175) {
              countArr = columnCountByScreen[1030];
            }
            if (tempScrollWidth >= 1175 && tempScrollWidth < 1290) {
              countArr = columnCountByScreen[1175];
            }
            if (tempScrollWidth >= 1290 && tempScrollWidth < 1570) {
              countArr = columnCountByScreen[1290];
            }
            if (tempScrollWidth >= 1570) {
              countArr = columnCountByScreen[1570];
            }
            const columnNumbers = countArr[index % columnWidth.length];
            tempColumn[columnWidth[index]] = columnNumbers;
            setColumn(state => ({
              ...state,
              [columnWidth[index]]: columnNumbers,
            }));
          }
          // eslint-disable-next-line no-restricted-globals
          else if (
            columnWidth[index] &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(columnWidth[index]) &&
            // eslint-disable-next-line no-restricted-globals
            !isNaN(gap) &&
            columnWidth[index] < tempWidth
          ) {
            const columnNumbers = Math.floor((tempWidth + gap) / (+columnWidth[index] + gap));
            tempColumn[columnWidth[index]] = columnNumbers;
            setColumn(state => ({
              ...state,
              [columnWidth[index]]: columnNumbers,
            }));
          }
        }

        // 计算图片相应宽度对应的高度(包括tpl的高度)
        const tplEl = document.getElementsByClassName(styles.tpl);
        if (tplEl && tplEl[0]) {
          setColumnHeight(state => ({
            ...state,
            tpl: window.getComputedStyle(tplEl[0]).height,
          }));
        }
        if (tempColumn && Object.keys(tempColumn).length > 0 && tempCss.width) {
          for (let i = 0; i < columnWidth.length; i += 1) {
            const realHeight = ((tempCss.width - 35) / tempColumn[columnWidth[i]]) * radio;
            setColumnHeight(state => ({
              ...state,
              [columnWidth[i]]: realHeight,
            }));
          }
        }
      }
    };
    if (node) {
      const ro = new ResizeObserver(entries => {
        setIsResize(true);
        calFunc(entries); // 计算变化
        if (window.autoWithTimer) {
          clearTimeout(window.autoWithTimer);
        }
        window.autoWithTimer = setTimeout(() => {
          // calFunc(entries);
          setIsResize(false);
        }, 100);
      });

      ro.observe(node);
    }
  };
  useEffect(() => {
    if (node) {
      setEl(node.querySelector('div'));
      // 计算该元素的宽高
      handleSize();
    }
  }, [node]);

  useEffect(() => {
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
  }, [el]);
  useEffect(() => {
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
      // 清楚定时器任务
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [el]);

  useEffect(() => {
    if (listRef.current) {
      data.forEach((_, i) => listRef.current.resetAfterIndex(i));
    }

    SetData(() => {
      // 处理只有单一列宽度数据，或者没有列宽度数据
      if (!columnWidth || columnWidth.length === 0) {
        return dataSource.length < count ? [...dataSource, null] : dataSource;
      }
      const list = [];
      let listIndex = 0;
      let row = [];
      let lastcolumnNumbers = 0;
      while (listIndex < dataSource.length) {
        const columnWidthIndex = list.length % columnWidth.length; // 计算取什么宽度的个数
        const columnNumbers = column[columnWidth[columnWidthIndex]]; // 计算列个数
        lastcolumnNumbers = columnNumbers;
        if (row.length < columnNumbers) {
          row.push(dataSource[listIndex]);
        }
        if (row.length === columnNumbers) {
          list.push([...row]);
          row = [];
        }
        listIndex += 1;
      }
      while (row.length !== 0 && row.length < lastcolumnNumbers) {
        row.push(null);
      }
      if (row.length > 0) {
        list.push([...row]);
      }

      // 处理加载中数据
      if (dataSource.length < count) {
        list.push(null);
      }

      return list;
    });
  }, [dataSource, column, columnWidth]);

  const loadMoreItems = (startIndex, stopIndex) => {
    loadData(startIndex, stopIndex);
  };

  const Row = ({ index, style }) => {
    return (
      <div style={{ ...style, backgroundColor: index === 0 ? 'transparent' : '#fff' }}>
        {index === 0 && tpl && (
          <div className={`${styles.tpl} `}>
            <div style={{ opacity: isScroll || isResize ? 1 : 0 }}>{tpl()}</div>
          </div>
        )}
        <div
          className={styles.rowInfinte}
          style={
            columnWidth && columnWidth.length > 1
              ? {
                  display: 'grid',
                  gridTemplateColumns: `repeat(${data &&
                    data[index] &&
                    data[index].length},minmax(${columnWidth[index % columnWidth.length] /
                    2}px,1fr))`,
                  gridColumnGap: `${gap}px`,
                  backgroundColor: '#fff',
                }
              : {
                  backgroundColor: '#fff',
                }
          }
        >
          {data &&
            data[index] &&
            data[index].map((item, key) => (
              <div
                key={`${index}_${key}`}
                className={classNames(styles.rowInfinteItem)}
                style={{ height: `${columnHeight[columnWidth[index % columnWidth.length]]}px` }}
              >
                {item && (
                  <>
                    {!isResize && template(item, key)}
                    {isResize && resizeTemplate && resizeTemplate(item)}
                    {!isResize && !resizeTemplate && template(item, key)}
                  </>
                )}
              </div>
            ))}
        </div>
        {index === data.length - 1 && dataSource.length < count && (
          <div className={styles.loader}>----------加载中----------</div>
        )}
        {index === data.length - 1 && dataSource.length >= count && dataSource.length > 12 && (
          <div className={styles.loader}>----------到底啦----------</div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const tplEl = document.getElementsByClassName(styles.tpl);
    if (tplEl && tplEl[0]) {
      setColumnHeight(state => ({
        ...state,
        tpl: window.getComputedStyle(tplEl[0]).height,
      }));
    }
  }, [dataSource]);

  return (
    <div className={styles.Infinite_container}>
      <div
        className={styles.Infinite_header}
        style={{
          opacity: isScroll || isResize ? 0 : 1,
          top: `-${scrollTop}px`,
          zIndex: isScroll || isResize ? 0 : 10,
        }}
      >
        <div className={styles.tpl}>{tpl && tpl()}</div>
      </div>
      {(!data || data.length === 0) && (loading === null || (loading !== null && !loading)) && (
        <div className={styles.blank}>{blank && blank()}</div>
      )}
      <div
        className={`${styles.InfiniteScroll} ${isResize ? styles.InfiniteScroll_hidden : ''}`}
        ref={r => setNode(r)}
        id="InfiniteScroll"
      >
        <InfiniteLoader
          isItemLoaded={index => {
            return !!data[index];
          }}
          itemCount={data && data.length}
          loadMoreItems={loadMoreItems}
          minimumBatchSize={minimumBatchSize}
          threshold={threshold}
        >
          {({ onItemsRendered, ref }) => (
            <List
              width={nodeStyle.width}
              height={nodeStyle.height}
              itemSize={getItemSize}
              itemCount={data.length}
              onItemsRendered={onItemsRendered}
              ref={list => {
                ref(list);
                listRef.current = list;
              }}
              useIsScrolling
            >
              {Row}
            </List>
          )}
        </InfiniteLoader>
        {!isWpPage && scroll && <div className={styles.scroll_top} onClick={handleScrollToTop} />}
        {/* {isWpPage && (
          <div className={styles.right_control}>
            <ScrollTopWhite node={el} quickly={true} />
            <BatchAdd
              scollNode={el}
              text={`将曾用壁纸加入轮播列表`}
              submitJson={{ groupType: 3 }}
            />
          </div>
        )} */}
      </div>
    </div>
  );
}

export default memo(GridInfinteScroll);
